import React, { useEffect } from 'react';
import { IconButton } from '@mui/material';
import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import dayjs from 'dayjs';
import useEventsControl, { monthNames, PERIOD } from './useEventsControl';

const ToggleTime = ({ getData, cons }) => {
  const today = dayjs();
  const { period, setPeriod, year, from, to, month, day, handleNext, handlePrev } = useEventsControl();

  const buttons = [
    { title: 'День', value: 'day' },
    { title: 'Месяц', value: 'month' },
    { title: 'Год', value: 'year' },
  ];

  const periodToInterval = {
    [PERIOD.DAY]: 'hour',
    [PERIOD.MONTH]: 'day',
    [PERIOD.YEAR]: 'month',
  };

  useEffect(() => {
    const interval = periodToInterval[period] ?? null;
    getData(from, to, interval);
  }, [day, month, year, period, cons]);

  const disabledNext =
    (period === PERIOD.MONTH && (year > today.year() || (year === today.year() && month >= today.month()))) || (period === PERIOD.YEAR && year >= today.year());

  const label =
    period === PERIOD.DAY ? dayjs(new Date(year, month, day)).format('DD.MM.YYYY') : period === PERIOD.MONTH ? `${monthNames[month]} ${year}` : year;

  return (
    <div className="relative flex items-center justify-center flex-wrap gap-2">
      <div className="flex items-center justify-center gap-2">
        <IconButton onClick={handlePrev}>
          <ArrowBackIosNew fontSize="small" />
        </IconButton>
        <p className="flex min-w-[120px] text-center justify-center font-semibold">{label}</p>
        <IconButton onClick={handleNext} disabled={disabledNext}>
          <ArrowForwardIos fontSize="small" />
        </IconButton>
      </div>

      <div className="sm:absolute right-0 ml-auto flex items-center gap-x-1 border w-fit border-gray-300 p-0.5 px-1 rounded-2xl">
        {buttons.map(({ title, value }) => {
          const isActive = period === value;
          return (
            <button
              key={value}
              type="button"
              onClick={() => setPeriod(value)}
              className={`px-2 py-1 rounded-[14px] cursor-pointer ${isActive ? 'bg-orange-500 text-white' : ''}`}>
              {title}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ToggleTime;
